import axios from '../../http.service';
import * as actionType from '../Enums/AmendContract.Enums';
import { ADD_TOAST_MESSAGE } from '../Enums/Contracts.Globals.Enums';

export const getAmendmentReason = () => {
	return async dispatch => {
		try {
			let resp = await axios.get(`/api/v2/release/amendContract/amendmentreasons`);
			const { errors = [] } = resp.data;
			const data = resp.status === 200 || resp.status === 304 ? resp.data.amendmentReasons : { data: [] };
			let payload = { data, errors };
			return dispatch({
				type: actionType.GET_AMENDMENTREASON,
				payload
			});
		} catch (error) {
			dispatch({
				type: ADD_TOAST_MESSAGE,
				payload: {
					severity: 'error',
					message: `Error while fetching Amendment Reasons ${error.message}`
				}
			});
			dispatch({
				type: actionType.AMENDCONTRACT_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching Amendment Reasons', error.message]
				}
			});
		}
	};
};

export const getAmendContractTeam = (year, appointmentTypes, query) => {
	return async dispatch => {
		try {
			let types = Object.assign({}, appointmentTypes);
			const typesEncoded = encodeURIComponent(JSON.stringify(types));
			const queryEncoded = encodeURIComponent(JSON.stringify(query));
            let resp = await axios.get(`/api/v2/release/amendContract/${year}/${typesEncoded}?pagination=${queryEncoded}`);
            
            const { errors = [] } = resp.data;
			const { data, total } = resp.status === 200 || resp.status === 304 ? resp.data.data[0] : { data: [], total: 0 };
			let payload = { data, total, errors };
			return dispatch({
				type: !query.flagExportData ? actionType.GET_AMENDCONTRACTTEAM : actionType.GET_AMENDCONTRACTTEAMEXPORT,
				payload
			});
		} catch (error) {
			dispatch({
				type: ADD_TOAST_MESSAGE,
				payload: {
					severity: 'error',
					message: `Error while fetching Amend Contract Team Data ${error.message}`
				}
			});
			dispatch({
				type: actionType.AMENDCONTRACT_ERROR,
				payload: {
					data: [],
					total: 0,
					errors: ['Error while fetching Amend Contract Team Data', error.message]
				}
			});
		}
	};
};

export const getAmendContractDetails = (year, markingTeamId, appointmentType, query) => {
	return async dispatch => {
		try {
			let resp = await axios.get(
				`/api/v2/release/amendContract/${year}/details/${markingTeamId}?appointmentType=${appointmentType}&pagination=${JSON.stringify(query)}`
			);
			const { errors = [] } = resp.data;
			const data = resp.status === 200 || resp.status === 304 ? resp.data.data[0].data : [];
			let payload = { data, errors };
			return dispatch({
				type: !query.flagExportData ? actionType.GET_AMENDCONTRACTDETAILS : actionType.GET_AMENDCONTRACT_DETAILS_EXPORT,
				payload
			});
		} catch (error) {
			dispatch({
				type: ADD_TOAST_MESSAGE,
				payload: {
					severity: 'error',
					message: `Error while fetching Amend Contract Data ${error.message}`
				}
			});
			dispatch({
				type: actionType.AMENDCONTRACT_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching Amend Contract Data', error.message]
				}
			});
		}
	};
};

export const saveAmendContract = amendContractData => {
	return async dispatch => {
		try {
			let resp = await axios.put(`/api/v2/release/amendContract/`, { amendContractModel: amendContractData });
			const data = resp.status === 200 ? resp.data.data.data : false;
			const { errors = [] } = resp.data.data;
			let payload = { data, errors };
			return dispatch({
				type: actionType.SAVE_AMENDCONTRACT,
				payload
			});
		} catch (error) {
			dispatch({
				type: actionType.AMENDCONTRACT_ERROR,
				payload: {
					data: false,
					errors: [error.message]
				}
			});
		}
	};
};

export const deleteAmendContract = amendContractIDs => {
	return async dispatch => {
		try {
			let resp = await axios.delete(`/api/v2/release/amendContract/`, { data: { ids: amendContractIDs } });
			const data = resp.status === 200 ? resp.data.data.data : false;
			const { errors = [] } = resp.data.data;
			let payload = { data, errors };
			return dispatch({
				type: actionType.DELETE_AMENDCONTRACT,
				payload
			});
		} catch (error) {
			dispatch({
				type: actionType.AMENDCONTRACT_ERROR,
				payload: {
					data: false,
					errors: [error.message]
				}
			});
		}
	};
};

export const addUpdateToAmendContract = (formUpdate = false) => {
	return dispatch => {
		try {
			return dispatch({
				type: actionType.AMENDCONTRACT_ADD_UPDATE,
				payload: { update: formUpdate, errors: [] }
			});
		} catch (err) {
			dispatch({ type: ADD_TOAST_MESSAGE, payload: { severity: 'error', message: err.message } });
			return dispatch({
				type: actionType.AMENDCONTRACT_ERROR,
				payload: { errors: [err.message] }
			});
		}
	};
};

export const clearAllAmendUpdates = () => {
	return dispatch => {
		return dispatch({
			type: actionType.AMENDCONTRACT_CLEAR_ALL_UPDATES,
			payload: {}
		});
	};
};

//severity: error/warning/info/success
export const showToastMessage = (severityType, displayMessage) => {
	return dispatch => {
		return dispatch({
			type: ADD_TOAST_MESSAGE,
			payload: { severity: severityType, message: displayMessage }
		});
	};
};

export const addAmendContractError = (displayMessage, error = '') => {
	return dispatch => {
		return dispatch({
			type: actionType.AMENDCONTRACT_ERROR,
			payload: { message: displayMessage, errors: [error] }
		});
	};
};

export const clearAmendContractError = () => {
	return dispatch => {
		return dispatch({
			type: actionType.AMENDCONTRACT_CLEAR,
			payload: { message: '', errors: [] }
		});
	};
};
